import { ShowFrontPage as DLShowFrontPage, StartGame as DLStartGame, OpenBriefcase as DLOpenBriefcase, ResetGame as DLResetGame, ContinueGame as DLContinueGame } from './../DL/Briefcase' //'./../../../DL/Admin/Games/Briefcase'

let briefcaseSocket = null; // Aficionado
let briefcaseIsConnected = false; // Aficionado

let briefcaseAdminSocket = null;
let isBriefcaseAdminConnected = false;
let briefcaseReconnectTimeout = null;
let briefcaseReconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 10;


const ConnectWebSocketForBriefcaseAdmin = (onIncomingMessage, onStatusChange = () => {}) => {
    if (briefcaseAdminSocket || isBriefcaseAdminConnected) return;

    const connectToWebSocket = () => {
        if (briefcaseReconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
            onStatusChange('error');
            console.warn('[Briefcase Admin WS] Límite de reconexiones alcanzado.');
            return;
        }

        briefcaseReconnectAttempts++;
        // Conectamos como superadmin para poder escuchar los eventos globales del juego
        briefcaseAdminSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=superadmin`);
        onStatusChange('connecting');

        briefcaseAdminSocket.onopen = () => {
            isBriefcaseAdminConnected = true;
            briefcaseReconnectAttempts = 0;
            onStatusChange('connected');
        };

        briefcaseAdminSocket.onmessage = (event) => {
            try {
                const parsedMessage = JSON.parse(event.data);
                // Filtramos para que este handler solo reaccione a mensajes de los maletines
                if (parsedMessage && parsedMessage.type && parsedMessage.type.toLowerCase().startsWith('briefcase.')) {
                    onIncomingMessage(parsedMessage);
                }
            } catch (error) {
                console.error('[Briefcase Admin WS] Error al parsear mensaje:', error);
            }
        };

        briefcaseAdminSocket.onclose = () => {
            isBriefcaseAdminConnected = false;
            briefcaseAdminSocket = null;
            onStatusChange('reconnecting');
            briefcaseReconnectTimeout = setTimeout(connectToWebSocket, 3000);
        };

        briefcaseAdminSocket.onerror = (error) => {
            console.error('[Briefcase Admin WS] Error de conexión:', error);
            onStatusChange('error');
        };
    };

    connectToWebSocket();
};

const DisconnectWebSocketForBriefcaseAdmin = () => {
    if (briefcaseAdminSocket) {
        briefcaseAdminSocket.onopen = null;
        briefcaseAdminSocket.onclose = null;
        briefcaseAdminSocket.onerror = null;
        briefcaseAdminSocket.onmessage = null;
        try { briefcaseAdminSocket.close(); } catch (error) { }
    }
    briefcaseAdminSocket = null;
    isBriefcaseAdminConnected = false;
    clearTimeout(briefcaseReconnectTimeout);
    briefcaseReconnectAttempts = 0;
};

const ShowBriefcaseFrontPage = async () => {
    return await DLShowFrontPage();
};

const StartBriefcaseGame = async (configurationData) => {
    try {
        // Validaciones básicas de seguridad
        if (!configurationData) return { success: false, message: 'Configuración inválida.' };
        if (configurationData.totalBriefcases < 2 || configurationData.totalBriefcases > 50) {
            return { success: false, message: 'La cantidad de maletines debe estar entre 2 y 50.' };
        }
        if (configurationData.suspenseDurationMs < 0) {
            return { success: false, message: 'El tiempo de suspenso no puede ser negativo.' };
        }

        // Limpieza de la lista de premios (convertir a Array limpio sin espacios extra)
        const rawPrizesList = configurationData.prizesListString || "";
        const cleanPrizesArray = rawPrizesList.split(',').map(prize => prize.trim());
        
        // Armamos el objeto final para el backend
        const finalConfiguration = {
            totalBriefcases: configurationData.totalBriefcases,
            suspenseDurationMs: configurationData.suspenseDurationMs,
            gameMode: configurationData.gameMode,
            winningAttempt: configurationData.winningAttempt,
            specialPrize: configurationData.specialPrize,
            prizes: cleanPrizesArray
        };

        const response = await DLStartGame(finalConfiguration);
        return response;
    } catch (error) {
        return { success: false, message: 'Excepción en BL al iniciar el juego de maletines.' };
    }
};

const OpenTargetBriefcase = async (briefcaseIdentifier) => {
    if (!briefcaseIdentifier || briefcaseIdentifier <= 0) {
        return { success: false, message: 'Identificador de maletín no válido.' };
    }
    return await DLOpenBriefcase(briefcaseIdentifier);
};

const ResetBriefcaseGame = async () => {
    return await DLResetGame();
};

const ContinueBriefcaseGame = async () => {
    return await DLContinueGame();
};

// const StartBriefcaseGame = async (configData) => {
//     try {
//         if (!configData || configData.totalBriefcases < 2) {
//             return { success: false, message: 'Configuración inválida.' };
//         }
//         const response = await DLStartGame(configData);
//         return response;
//     } catch (error) {
//         return { success: false, message: 'Excepción en BL al iniciar.' };
//     }
// };

// const OpenBriefcase = async (briefcaseId) => {
//     try {
//         if (!briefcaseId) return { success: false, message: 'ID de maletín no válido.' };
//         const response = await DLOpenBriefcase(briefcaseId);
//         return response;
//     } catch (error) {
//         return { success: false, message: 'Excepción en BL al abrir maletín.' };
//     }
// };

// const ResetBriefcaseGame = async () => {
//     try {
//         const response = await DLResetGame();
//         return response;
//     } catch (error) {
//         return { success: false, message: 'Excepción en BL al reiniciar.' };
//     }
// };

//=== Aficionado ===//

// ==========================================================================
// 🔌 WEBSOCKET (Dedicado a Briefcase VIP)
// ==========================================================================
const ConnectBriefcaseWebSocket = async (onStatus = () => {}, onToast = () => {}) => {
    if (briefcaseSocket || briefcaseIsConnected) return;

    const connect = () => {
        if (briefcaseReconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
            onStatus('error'); 
            return;
        }
        
        briefcaseReconnectAttempts++;
        // Conectamos con el tipo exacto que espera el Backend en C#
        briefcaseSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=briefcase:aficionado`);
        onStatus('connecting');

        briefcaseSocket.onopen = () => {
            briefcaseIsConnected = true;
            briefcaseReconnectAttempts = 0;
            onStatus('connected');
            onToast('Conectado');
        };

        briefcaseSocket.onclose = () => {
            briefcaseIsConnected = false;
            briefcaseSocket = null;
            onStatus('reconnecting');
            briefcaseReconnectTimeout = setTimeout(connect, 2000);
        };

        briefcaseSocket.onerror = () => onStatus('error');
    };
    
    connect();
};

const SetBriefcaseSocketMessageHandler = (handler) => {
    if (!briefcaseSocket) return;
    briefcaseSocket.onmessage = (evt) => {
        try { 
            handler(JSON.parse(evt.data)); 
        } catch (error) { 
            console.error("Error parseando mensaje WS Briefcase:", error);
        }
    };
};

const ClearBriefcaseSocketMessageHandler = () => {
    if (briefcaseSocket) briefcaseSocket.onmessage = null;
};

const DisconnectBriefcaseWebSocket = () => {
    try {
        if (briefcaseSocket) {
            briefcaseSocket.onopen = null;
            briefcaseSocket.onclose = null;
            briefcaseSocket.onerror = null;
            briefcaseSocket.onmessage = null;
            briefcaseSocket.close();
            briefcaseSocket = null;
            briefcaseIsConnected = false;
            clearTimeout(briefcaseReconnectTimeout);
            briefcaseReconnectAttempts = 0;
        }
    } catch (error) { }
};

// ==========================================================================
// 📡 REST API (Peticiones al servidor)
// ==========================================================================
const SendMainBriefcaseSelection = async (briefcaseId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Player/SelectMain`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ briefcaseId: briefcaseId })
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

const SendTargetBriefcase = async (briefcaseId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Briefcase/Player/TargetNext`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ briefcaseId: briefcaseId })
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

//=== Aficionado ===//

export { ConnectWebSocketForBriefcaseAdmin, DisconnectWebSocketForBriefcaseAdmin, ShowBriefcaseFrontPage, StartBriefcaseGame, OpenTargetBriefcase, ResetBriefcaseGame, ContinueBriefcaseGame, ConnectBriefcaseWebSocket, SetBriefcaseSocketMessageHandler, ClearBriefcaseSocketMessageHandler, DisconnectBriefcaseWebSocket, SendMainBriefcaseSelection, SendTargetBriefcase };